module.exports = __webpack_public_path__ + "img/cursor.1db0e1ae.svg";